module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/en/1/5-31fd73cb934e8949507917ab541a099a.jpg";